import Button from "../Shared/Button";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { searchPatients } from "../../state/actions/workflow";
import _ from "lodash";
import { formatDateTime } from "../../utils";

const PatientSearchingTable = ({ selectedPatient, onSelectPatient }) => {
  const [searchPatientName, setSearchPatientName] = useState("");
  const [patientRows, setPatientRows] = useState([]);
  const [isSearchingPatients, setIsSearchingPatients] = useState(false);
  const [failureReason, setFailureReason] = useState(null);

  const practitioners = useSelector((state) => state.app.practitioners);

  const handleSearchPatients = async () => {
    setIsSearchingPatients(true);
    const { hasError, errorText = "", patients = [] } = await searchPatients(searchPatientName);
    if (hasError) {
      setFailureReason(errorText);
    }
    setPatientRows(
      patients.map((patient) => {
        const practitioner = _.find(
          practitioners,
          (practitioner) => practitioner.practitionerId === patient.practitionerId
        );
        const practitionerFullName = `${_.get(practitioner, "firstName", "")} ${_.get(practitioner, "lastName", "")}`;
        return {
          patientId: patient.clientId,
          fullname: `${patient.firstName} ${patient.lastName}`,
          dob: formatDateTime(patient.dateOfBirth, false, false),
          gender: _.get(patient, "gender", ""),
          practitionerFullName,
        };
      })
    );
    setIsSearchingPatients(false);
  };

  return (
    <>
      <div className="field has-addons">
        <div className="control is-expanded">
          <input
            className="input is-radiusless is-size-7"
            type="text"
            placeholder="Search client by entering client's name here"
            value={searchPatientName}
            onChange={(e) => {
              setFailureReason(null);
              setSearchPatientName(e.target.value);
            }}
            onKeyPress={(e) => {
              if (e.which === 13) {
                handleSearchPatients();
              }
            }}
          />
        </div>
        <div className="control">
          <Button text="Search" onClick={handleSearchPatients} isLoading={isSearchingPatients} />
        </div>
      </div>
      <p className="has-text-danger">{failureReason}</p>
      <div className="table-container apt-table">
        <table className="table is-fullwidth is-stripe is-hoverable is-scrollable is-size-7">
          <thead>
            <tr>
              <th>Fullname</th>
              <th>Practitioner</th>
              <th>DOB</th>
              <th>Gender</th>
            </tr>
          </thead>
          <tbody>
            {patientRows.length === 0 && (
              <tr>
                <td>No results</td>
              </tr>
            )}
            {patientRows.map((row) => (
              <tr
                key={row.patientId}
                className={`${row.patientId === selectedPatient?.patientId ? "is-active " : ""}is-hovered`}
                onClick={() => onSelectPatient(row)}
              >
                <td>{row.fullname}</td>
                <td>{row.practitionerFullName}</td>
                <td>{row.dob}</td>
                <td>{row.gender}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default PatientSearchingTable;
